import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the defense catches a ball off the rebound net (Indoor Football).
 * This is a RETURN (not an interception) - the defense gains possession of a live ball.
 * Similar to fielding a punt, the player is returning the ball.
 */
export default class ReboundNetCaughtDefense extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.ReboundNetCaughtDefense
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { caughtBy, caughtAt } = fragment;

        // Defense gains possession
        if (caughtBy) {
            gameContext.setPossessionForTeamId(caughtBy.teamId);
            gameContext.setCurrentPlayerInPossession(caughtBy);
        }
        if (caughtAt || caughtAt === 0) {
            gameContext.setFieldPosition(caughtAt);
        }
        ruleContext.setAwardFirstDown(true);
    }
}
